<template>
  <v-container>
    <h3 class="display-3">{{title ? title : 'Resource Not Found'}}</h3>
    <span class="subheading">
      Sorry, we cannot find what you are looking for.
      <br />
      <template v-if="badURL">
        The URL
        <b>'{{ badURL }}'</b> did not match any resource in the system.
        <br />
      </template>
    </span>
    <v-divider class="mt-2"></v-divider>

    <div class="subheading mb-2">For support, please call 1-866-926-3261.</div>
    <v-btn @click="$router.push('/')" color="primary" large style="margin: 0" class="mb-2">
      <v-icon class="mr-1">home</v-icon>{{$t('App.Home')}}
    </v-btn>
  </v-container>
</template>

<script>
  export default {
    components: {},
    props: {
      badURL: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
    },
    data() {
      return {}
    },
    computed: {},
    methods: {},
    mounted() {},
  }
</script>